import React, { useState } from "react";
import PropTypes from "prop-types";
import FixedBox from "./FixedBox";

import Tooltip from "./tooltip";
import getRelativePosition from "./helpers";

const DataGrid = ({
  xLabels,
  yLabels,
  data,
  xLabelWidth,
  yLabelWidth,
  background,
  height,
  yLabelTextAlign,
  unit,
  displayYLabels,
  onClick,
  cursor,
  squares,
  cellRender,
  cellStyle,
  title,
  hoverStyles,
  numberViews,
  onMouseEnter,
  onMouseOut
}) => {
  const flatArray = data.reduce((i, o) => [...o, ...i], []);
  const max = Math.max(...flatArray);
  const min = Math.min(...flatArray);

  const [tooltip, setStateToolTip] = useState({
    open: false,
    x: 0,
    y: 0
  });

  const GridRef = React.useRef();

  return (
    <div ref={GridRef}>
      {yLabels.map((y, yi) => (
        <div key={yi} style={{ display: "flex" }}>
          <FixedBox width={yLabelWidth}>
            <div
              className="heatmap--Ylabel"
              style={{
                textAlign: yLabelTextAlign,
                paddingRight: "5px",
                paddingTop: "13.1px", //`${height / 3.7}px`,
                width: `${yLabelWidth}px`
              }}
            >
              {displayYLabels && y}
            </div>
          </FixedBox>
          {xLabels.map((x, xi) => {
            const value = data[yi][xi];
            const style = Object.assign(
              {
                cursor: `${cursor}`,
                margin: "1px 1px 0 0",
                height,
                width: squares ? `${height}px` : undefined,
                flex: squares ? "none" : 1,
                textAlign: "center"
              },
              cellStyle(background, value, min, max, data, xi, yi)
            );
            return (
              <div
                onClick={onClick.bind(this, xi, yi)}
                key={`${xi}_${yi}`}
                style={style}
                className="heatmapbox"
                // onMouseEnter={e => {
                //   onMouseEnter(e, value);
                // }}
                // onMouseOut={onMouseOut}
                onMouseEnter={e => {
                  if (GridRef && GridRef.current) {
                    const { x: x2, y: y2 } = getRelativePosition(
                      e.target,
                      GridRef.current
                    );
                    setStateToolTip({
                      x: x2,
                      y: y2,
                      open: true,
                      views: value
                      // /date: null //yLabels[yi]
                    });
                  }
                }}
                onMouseOut={e => {
                  setStateToolTip({
                    open: false,
                    views: 2
                  });
                }}
              >
                {/* <div
                  style={{ paddingTop: `${height / 3.7}px` }}
                  className="heatmapbox--padder"
                >
                  {cellRender(value, x, y)}
                </div> */}
                {/* <div style={hoverStyles} className="heatmapbox--hoverbox">
                  <h4 className="heatmapbox--hoverboxtitle">
                    {xLabels[xi]}, {yLabels[yi]}
                  </h4>
                  <h5 className="heatmapbox--hoverboxname">
                    {numberViews(value)} <span>views</span>
                  </h5>
                </div> */}
              </div>
            );
          })}
        </div>
      ))}
      <Tooltip {...tooltip} />
    </div>
  );
};

DataGrid.propTypes = {
  xLabels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  yLabels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
  background: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  xLabelWidth: PropTypes.number.isRequired,
  yLabelWidth: PropTypes.number.isRequired,
  yLabelTextAlign: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  displayYLabels: PropTypes.bool,
  onClick: PropTypes.func,
  cursor: PropTypes.string,
  squares: PropTypes.bool,
  cellRender: PropTypes.func.isRequired,
  cellStyle: PropTypes.func.isRequired,
  title: PropTypes.func
};

DataGrid.defaultProps = {
  displayYLabels: true,
  cursor: "",
  onClick: () => {},
  squares: false,
  title: (value, unit) => (value || value === 0) && `${value} ${unit}`
};

export default DataGrid;



// WEBPACK FOOTER //
// ./src/DataGrid.jsx